export default __webpack_public_path__ + "static/media/next.b1d083fc.svg";